import ReactLoading from "react-loading";

/**
 * Loading screen
 * @param displayed If true then the loading screen is displayed 
 * @returns 
 */
export default function LoadingScreen({displayed=true}) {


    return (<>
        <div className={displayed ? "loading-screen" : "hide-input"}>
        <ReactLoading type="spin" color="#124191"
        height={100} width={50} />
        </div>
    </>)
}